// extracted by mini-css-extract-plugin
module.exports = {"root":"ServicesSection-module--root--2n6CI","title":"ServicesSection-module--title--C7Fz-"};